import React, { useState } from "react";
import { PageHero, PageBody } from "./_shared";
import { useNursing } from "./NursingLayout";
import { User, Quote } from "lucide-react";

export default function Leadership() {
  const data = useNursing();
  const list = data.leadership || [];
  const [active, setActive] = useState(list[0]?.id || null);
  const cur = list.find((l) => l.id === active) || list[0];

  return (
    <div data-testid="nur-leadership">
      <PageHero eyebrow="Our People" title="Leadership Messages" />
      <PageBody>
        {list.length === 0 ? (
          <div className="bg-white rounded-2xl p-12 text-center text-sm text-[#475569] ring-1 ring-[#E2E8F0]">
            Leadership messages will appear here once published by the institute.
          </div>
        ) : (
          <div className="grid md:grid-cols-[260px_1fr] gap-6">
            <aside className="bg-white rounded-2xl ring-1 ring-[#E2E8F0] md:sticky md:top-32 self-start overflow-hidden shadow-sm">
              <div className="px-4 py-3 border-b border-[#E2E8F0] text-[10px] uppercase tracking-[0.25em] text-[#0FB28A] font-bold">Leaders</div>
              {list.map((l) => {
                const a = l.id === cur?.id;
                return (
                  <button key={l.id} onClick={() => setActive(l.id)}
                    data-testid={`nur-leader-${l.id}`}
                    className={`w-full text-left px-4 py-3 flex items-center gap-3 border-l-4 ${a ? "border-[#0FB28A] bg-[#E0F5EE]" : "border-transparent hover:bg-[#F4F6FA]"}`}>
                    {l.photo_url ? (
                      <img src={l.photo_url} alt={l.name} className="w-10 h-10 rounded-full object-cover shrink-0" />
                    ) : (
                      <div className="w-10 h-10 rounded-full bg-[#E0F5EE] text-[#0E916F] flex items-center justify-center shrink-0"><User size={16} /></div>
                    )}
                    <div className="min-w-0">
                      <div className="text-sm text-[#0F2A5F] truncate font-medium">{l.name}</div>
                      {l.designation && <div className="text-[10px] uppercase tracking-wider text-[#475569] truncate">{l.designation}</div>}
                    </div>
                  </button>
                );
              })}
            </aside>
            {cur && (
              <article className="bg-white rounded-2xl ring-1 ring-[#E2E8F0] p-8 shadow-sm">
                <div className="flex items-start gap-5 flex-wrap">
                  {cur.photo_url ? (
                    <img src={cur.photo_url} alt={cur.name} className="w-28 h-28 rounded-full object-cover ring-4 ring-[#0FB28A]/30 shrink-0" />
                  ) : (
                    <div className="w-28 h-28 rounded-full bg-[#E0F5EE] text-[#0E916F] flex items-center justify-center shrink-0"><User size={36} /></div>
                  )}
                  <div className="flex-1 min-w-[200px]">
                    <h2 className="font-['Poppins',sans-serif] font-bold text-2xl text-[#0F2A5F]">{cur.name}</h2>
                    {cur.designation && <div className="mt-1 text-[11px] uppercase tracking-wider text-[#0FB28A] font-bold">{cur.designation}</div>}
                  </div>
                </div>
                {cur.message_html && (
                  <div className="mt-7 relative">
                    <Quote size={36} className="absolute -top-2 -left-1 text-[#E0F5EE]" />
                    <div
                      className="pl-10 text-[15px] text-[#475569] leading-relaxed prose prose-sm max-w-none prose-p:my-2"
                      dangerouslySetInnerHTML={{ __html: cur.message_html }}
                    />
                  </div>
                )}
              </article>
            )}
          </div>
        )}
      </PageBody>
    </div>
  );
}
